module.exports = __webpack_public_path__ + "static/media/may_2025_3.065b5d69.webp";